import { isPlainObject } from "~/tools/is-plain-object";
import type { Record } from "~/tools/record";

export function hasProperty<TObject, TKey extends PropertyKey>(
	obj: TObject,
	key: TKey,
): obj is TObject & Record<TKey, unknown, "writable"> {
	return isPlainObject(obj) && key in obj;
}
